/**
 * @file ProductListPanels.tsx
 * @description Панели списков на странице товара (phase19.16 Р2а;
 * uiux-design-r2a §3): «Отзывы о товаре» — сколько показать (дальше «Все
 * отзывы»); «Похожие товары» — сколько, в ряд на ПК, на телефоне. Карточка
 * похожего товара — та же, что в каталоге («Сайт → Каталог»).
 * SB120 этап 3б: в ряд 1–6 числом, на телефоне схемами, строка «Шрифт и
 * цвет карточек — в Каталоге →» вместо группы «Цвет и шрифт» (TD-436).
 */

import { GRID_PER_ROW, SITE_LIMITS, defaultElementBody } from "@chaiberi/shared";

import { Label } from "../../../../ui/label";
import { SelectField } from "../../../../ui/SelectField";
import { CatalogCardFontLine } from "../CatalogCardFontLine";
import { GridCountField } from "../GridCountField";
import { PhoneGridField } from "../PhoneGridField";
import type { ElementPanelProps } from "../types";
import { ProductNote } from "./ProductNote";

const range = (from: number, to: number) => Array.from({ length: to - from + 1 }, (_, i) => from + i);
const numberOptions = (values: number[]) => values.map((n) => ({ value: String(n), label: String(n) }));

export function ProductReviewsPanel({ element, onChange }: ElementPanelProps<"product-reviews">) {
  return (
    <>
      <div className="flex flex-col gap-1">
        <Label>Сколько отзывов показать</Label>
        <SelectField ariaLabel="Сколько отзывов показать" value={String(element.limit)} options={numberOptions(range(1, SITE_LIMITS.productReviews))} onChange={(v) => onChange({ ...element, limit: Number(v) })} />
      </div>
      <ProductNote>Остальные — по ссылке «Все отзывы». Нет отзывов у товара — элемента на его странице не будет.</ProductNote>
    </>
  );
}

const RELATED_COLS = defaultElementBody("product-related").perRow;

export function ProductRelatedPanel({ element, onChange, path }: ElementPanelProps<"product-related">) {
  return (
    <>
      <div className="flex flex-col gap-1">
        <Label>Сколько товаров</Label>
        <SelectField ariaLabel="Сколько похожих товаров" value={String(element.limit)} options={numberOptions(range(2, SITE_LIMITS.productRelated))} onChange={(v) => onChange({ ...element, limit: Number(v) })} />
      </div>
      <GridCountField kind="product-related" field="perRow" values={GRID_PER_ROW} value={element.perRow} fallback={RELATED_COLS} path={path} onChange={(perRow) => onChange({ ...element, perRow: perRow ?? RELATED_COLS })} />
      <PhoneGridField ariaLabel="Похожие на телефоне" value={element.phoneLayout} onChange={(phoneLayout) => onChange({ ...element, phoneLayout })} />
      <ProductNote>Товары той же категории. Карточка — как в каталоге сайта.</ProductNote>
      <CatalogCardFontLine />
    </>
  );
}
